<template>
  <div class="row" >
    <div class="col-md-6" v-if="user || isLoadingUser">
      <loading-card v-if="isLoadingUser" title="Profile" />
      <card title="Profile" v-else-if="user" >
        <div class="profile" >
          <profile-row heading="Name" :info="user.full_name" />
          <profile-row heading="Email" :info="user.email" />
          <profile-row heading="Organization" v-if="user.organization" :info="user.organization.name" />
          <profile-row heading="Group" v-if="user.group" :info="user.group.name" />
          <profile-row heading="Role" v-if="user.role" :info="user.role.name" />
        </div>
      </card>
    </div>
    <div class="col-md-6">
      <card class="card" title="Change Password">
        <form @submit.prevent>
          <div class="row">
            <div class="col-12">
              <fg-input type="password"
              placeholder="Password"
              :class="{ 'form-group--error': $v.password.$error }"
              v-model="$v.password.$model">
            </fg-input>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <fg-input type="password"
            placeholder="Confirm Password"
            :class="{ 'form-group--error': $v.confirmPassword.$error }"
            v-model="$v.confirmPassword.$model">
          </fg-input>
        </div>
      </div>
      <div class="text-left">
        <p-button type="info"
        :loading="isChangingPassword"
        @click.native.prevent="changePassword">
        Save
      </p-button>
    </div>
    <!-- <div class="clearfix"></div> -->
  </form>
</card>
</div>

<div class="col-md-6" v-if="canChangeApiKey">
  <card class="card" title="Application API Key">
    <form @submit.prevent>
      <div class="row" v-if="apiKey">
        <div class="col-12">
            <h6>Your new API key was created and <strong>will be displayed only once!</strong></h6>
            <div class="input-group input-group-lg mb-3">
              <input id="api-key" type="text" class="form-control" readonly :value="apiKey">
              <button class="btn" @click="copyKey">COPY</button>
            </div>
            <p>Copy the key now and store it securely. The key cannot be viewed once you navigate away from this page.</p>
        </div>
      </div>
      <div class="row" v-else>
        <div class="col-12">
          <p v-if="user.has_api_key">An API key is active</p>
          <div class="d-flex">
            <p-button type="danger" class="mr-2"
              :loading="isChangingPassword"
              :disabled="!user.has_api_key"
              @click.native.prevent="removeApiKey">
              Remove
            </p-button>
            <p-button type="info"
              :loading="isChangingPassword"
              @click.native.prevent="resetApiKey">
              {{ user.has_api_key ? 'Reset' : 'Set' }}
            </p-button>
          </div>
        </div>
      </div>
  <!-- <div class="clearfix"></div> -->
</form>
</card>
</div>

</div>
</template>

<script>
import ProfileRow from '../components/ProfileRow.vue';
import Card from '../components/Cards/Card.vue';
import LoadingCard from '../components/Cards/LoadingCard.vue';
import { required, sameAs } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';
import { notify } from '../services/notify';

export default {
  components: {
    ProfileRow,
    Card,
    LoadingCard
  },
  data() {
    return {
      password: "",
      confirmPassword: "",
      isLoadingUser: false,
      isChangingPassword: false,
      isChangingApiKey: false,
    }
  },
  validations: {
    password: { required },
    confirmPassword: { sameAsPassword: sameAs('password') }
  },
  created() {
    if (!this.user) {
      this.fetchMe();
    }
  },
  async beforeDestroy() {
    await this.$store.dispatch('user/clearApiKey');
  },
  methods: {
    async fetchMe() {
      this.isLoadingUser = true;
      await this.$store.cache.dispatch('user/fetchMe');
      this.isLoadingUser = false;
    },
    async changePassword() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        notify().error('Please make sure your password is the same.')
        return;
      }

      this.isChangingPassword = true;
      const success = await this.$store.dispatch('user/updateMe', {
        password: this.password
      });
      this.isChangingPassword = false;

      if (success) {
        this.resetPasswordForm();
      }
    },
    resetPasswordForm() {
      this.password = "";
      this.confirmPassword = "";
      this.$v.$reset();
    },
    async resetApiKey() {
      this.isChangingApiKey = true;
      const success = await this.$store.dispatch('user/createApiKey');
      this.isChangingApiKey = false;
    },
    async removeApiKey() {
      this.isChangingApiKey = true;
      const success = await this.$store.dispatch('user/deleteApiKey');
      this.isChangingApiKey = false;
    },
    copyKey() {
      let copyInput = document.getElementById("api-key");
      copyInput.select();
      copyInput.setSelectionRange(0, 99999);

      document.execCommand("copy");
      notify().success('Success! Copied response key to clipboard.');
      copyInput.blur();
    },
  },
  computed: {
    ...mapGetters('user', ['user', 'apiKey']),
    canChangeApiKey: function() {
      if (!this.user) return false;
      let role = this.user.role.id;
      console.log(role);
      if (role === 'super' || role === 'staff' || role === 'partner' || role === 'manager') {
        return true;
      }
      else {
        return false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.profile {
  padding-left: 10px;
}
</style>
